module.exports = __webpack_public_path__ + "static/media/eye.e3a39c5f.svg";